// extracted by mini-css-extract-plugin
export default {"actions":"UserRowCells_actions__wY+a0"};